
































import { defineComponent, ref, PropType } from "@vue/composition-api";
import OccBody from "@/components/Atoms/OccBody/index.vue";
import OccTooltip from "@/components/Atoms/OccTooltip/OccTooltip.vue";
export default defineComponent({
  name: "OccHelp",
  components: {
    OccBody,
    OccTooltip
  },
  props: {
    angle: {
      type: String,
      default: ""
    },
    top: {
      type: String,
      default: ""
    },
    left: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: "black"
    },
    color: {
      type: String,
      default: "white"
    },
    width: {
      type: String,
      default: ""
    },
    customSize: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: "font-light"
    },
    helpText: {
      type: String,
      default: ""
    },
    helpLink: {
      type: Object as PropType<{ href: string; text: string }>,
      default: undefined
    }
  },
  setup(_props) {
    const tooltipHelp = ref<boolean>(false);
    return {
      tooltipHelp
    };
  }
});
